import { Container } from "reactstrap";
import { Outlet, useNavigate } from "react-router-dom";
import { Center, Flex, Loader } from "@mantine/core";
import styled from "@emotion/styled";
import TopBar from "../../components/TopBar";
import { checkToken, useAuth } from "../../auth/AuthContext";
import { useEffect } from "react";

const StyledContainer = styled(Container)`
  padding-top: 6rem;
  overflow-y: scroll;
  height: 100vh;
`;
const StyledFlex = styled(Flex)`
  background-color: #fafafa;
`;

function AdminLayout() {
  const { access_token, isAdmin, isLoading } = useAuth();
  const isAuthenticated = checkToken(access_token!);
  const navigate = useNavigate();
  useEffect(() => {
    if ((!isAuthenticated || !isAdmin) && !isLoading) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, isAdmin, isLoading])

  if (isLoading) {
    return <Center style={{ marginTop: "25%" }}>
      <Loader />
    </Center>
  }
  // debugger;

  return (
    <StyledFlex>
      <TopBar />
      <StyledContainer>
        <Outlet />
      </StyledContainer>
    </StyledFlex>
  );
}

export default AdminLayout;
